// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__C2zDB","right":"styles_right__3x52d"};